var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Loader"},[_c('div',{class:_vm.statusClassLoader},[_c('div',{class:_vm.statusClassCheckmark})]),(_vm.status=='error')?_c('div',[_c('img',{staticClass:"error-triangle",attrs:{"src":require("@/assets/error-triangle.svg")}})]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0b7e68","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loader.vue
// module id = null
// module chunks = 